import type {
  AgentJob,
  IAgentNeedsYouItem,
  IDevAgentStatus,
  ITaskAgentPipeline,
  ITaskAgentPipelineSummary,
} from '@common/interfaces/agentPipeline'
import Base, { Wrapped } from './base'

export default class AgentPipeline extends Base {
  show(taskId: string): Wrapped<ITaskAgentPipeline> {
    return this.apiClient.get(`/tasks/${taskId}/agent-pipeline`)
  }

  listSummaries(taskIds: string[]): Wrapped<ITaskAgentPipelineSummary[]> {
    return this.apiClient.post('/agent-pipeline/summaries', { taskIds })
  }

  handTask(taskId: string, job: AgentJob): Wrapped<ITaskAgentPipeline> {
    return this.apiClient.put(`/tasks/${taskId}/agent-handoff`, { job })
  }

  takeOver(taskId: string): Wrapped<ITaskAgentPipeline> {
    return this.apiClient.post(`/tasks/${taskId}/agent-handoff/take-over`)
  }

  listNeedsYou(): Wrapped<IAgentNeedsYouItem[]> {
    return this.apiClient.get('/dev-agent/needs-you')
  }

  getStatus(): Wrapped<IDevAgentStatus> {
    return this.apiClient.get('/dev-agent/status')
  }

  setPaused(isPaused: boolean): Wrapped<IDevAgentStatus> {
    return this.apiClient.put('/dev-agent/paused', { isPaused })
  }
}
